/**
 * Country Detection Utility
 * Detects user's country using browser timezone and language for localized pricing.
 */

const TIMEZONE_COUNTRY_MAP = {
  // India
  "Asia/Kolkata": "IN",
  "Asia/Calcutta": "IN",
  // United States
  "America/New_York": "US",
  "America/Chicago": "US",
  "America/Denver": "US",
  "America/Los_Angeles": "US",
  "America/Phoenix": "US",
  "America/Anchorage": "US",
  "Pacific/Honolulu": "US",
  "America/Detroit": "US",
  "America/Indiana/Indianapolis": "US",
  // United Kingdom
  "Europe/London": "GB",
  // EU countries
  "Europe/Paris": "FR",
  "Europe/Berlin": "DE",
  "Europe/Rome": "IT",
  "Europe/Madrid": "ES",
  "Europe/Amsterdam": "NL",
  "Europe/Brussels": "BE",
  "Europe/Vienna": "AT",
  "Europe/Dublin": "IE",
  "Europe/Lisbon": "PT",
  "Europe/Helsinki": "FI",
  "Europe/Stockholm": "SE",
  "Europe/Copenhagen": "DK",
  "Europe/Warsaw": "PL",
  "Europe/Prague": "CZ",
  "Europe/Budapest": "HU",
  "Europe/Bucharest": "RO",
  "Europe/Athens": "GR",
  "Europe/Sofia": "BG",
  "Europe/Vilnius": "LT",
  "Europe/Riga": "LV",
  "Europe/Tallinn": "EE",
  "Europe/Ljubljana": "SI",
  "Europe/Bratislava": "SK",
  "Europe/Zagreb": "HR",
  "Europe/Luxembourg": "LU",
  "Europe/Malta": "MT",
  // Canada
  "America/Toronto": "CA",
  "America/Vancouver": "CA",
  "America/Edmonton": "CA",
  "America/Winnipeg": "CA",
  "America/Halifax": "CA",
  "America/St_Johns": "CA",
  // Australia
  "Australia/Sydney": "AU",
  "Australia/Melbourne": "AU",
  "Australia/Perth": "AU",
  "Australia/Brisbane": "AU",
  "Australia/Adelaide": "AU",
  "Australia/Hobart": "AU",
  "Australia/Darwin": "AU",
};

/**
 * Detect user's country code using browser timezone and language.
 * Returns a 2-letter ISO country code (e.g., "US", "IN", "GB").
 */
export const detectUserCountry = () => {
  try {
    // Strategy 1: Timezone-based detection (most reliable)
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && TIMEZONE_COUNTRY_MAP[tz]) {
      return TIMEZONE_COUNTRY_MAP[tz];
    }

    // Strategy 2: navigator.language region suffix (e.g., "en-US" -> "US")
    const lang = navigator.language || navigator.languages?.[0];
    if (lang && lang.includes("-")) {
      const parts = lang.split("-");
      const region = parts[parts.length - 1].toUpperCase();
      if (region.length === 2) return region;
    }

    return "US"; // Default fallback
  } catch {
    return "US";
  }
};
